import { BasicComponent } from "haxt";

import "./ReturnPage.scss";

export class ReturnPage extends BasicComponent<{
	page: string;
	parts: string[];
}> {

	sessionData: any = null;

	@BasicComponent.initialize()
	async processStripe() {
		const urlParams = new URLSearchParams(window.location.search);
		const session_id = urlParams.get('session_id');
		if (!session_id) {
			return;
		}

		const session = await fetch(`/stripe/session_status?session_id=${session_id}`);
		let sessionData = await session.json();
		this.sessionData = sessionData;

		this.update();
	}

	public render() {
		return (
			<div class="ReturnPage">
				<h1>Return Page</h1>
				<pre>{JSON.stringify(this.sessionData, null, 2)}</pre>
			</div>
		);
	}
}
